import {
  Box,
  Chip,
  CircularProgress,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import vendorUserLogo from "../../assets/images/vendorUser.svg";
import {
  EditIcon,
  addIcon,
  crossIcon,
  removeIcon,
  tickIcon,
} from "../../assets/uppoIcons/icons";
import { useTheme } from "@mui/material/styles";
import ReactPagination from "../../components/pagination/Pagination";
import { ThemeConfig } from "../../dataTypes/ThemeConfig";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
interface VendorUser {
  id: number;
  name: string;
  email: string;
  isActive: boolean;
}

interface VendorUserProps {
  themeConfig: ThemeConfig;
}

export const VendorUser: React.FC<VendorUserProps> = ({ themeConfig }) => {
  const theme = useTheme();
  const { slug, id } = useParams<{ slug: string; id: string }>();
  const location = useLocation();
  const state = location.state as { name?: string; path?: string };
  const { name, path } = state || {};
  const [vendorUser, setVendorUser] = useState<VendorUser[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage - 1);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedVendorUsers = vendorUser.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  useEffect(() => {
    const fetchVendorUser = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("No token found");
        }

        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/${slug}/admin/getVendorUsers/${id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch vendor users");
        }
        const data = await response.json();
        setVendorUser(data.data.users);
      } catch (error) {
        console.error("Error fetching vendor users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchVendorUser();
  }, [slug, id]);

  return (
    <Box
      sx={{
        bgcolor: "#fff",
        margin: "40px auto ",
        display: "flex",
        flexDirection: "column",
        maxHeight: 1000,
        width: 918,
        justifyContent: "space-between",
      }}
    >
      <Box
        maxHeight="800px"
        overflow="auto"
        width={918}
        padding="40px 130px"
        sx={{
          bgcolor: "#fff",
          // margin: "54px auto 0px auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: "11px",
              alignItems: "center",
              paddingBottom: "22px",
            }}
          >
            <img src={path} alt="" style={{ width: "100px", margin: "0px" }} />
            <Typography sx={{ fontSize: "25px", fontWeight: 500 }}>
              {name || "Parceiro 1"}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ fontSize: "25px", fontWeight: 700 }}>
              Usuários
            </Typography>
            <Box
              // color="inherit"
              sx={{
                height: "45px",
                width: "45px",
                marginBottom: "5px",
                backgroundColor: themeConfig.color,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "4px",
                color: theme.palette.getContrastText(themeConfig.color),
              }}
            >
              {" "}
              <PersonAddAltOutlinedIcon
                sx={{ color: theme.palette.getContrastText(themeConfig.color) }}
              />
            </Box>
          </Box>

          <Box>
            {loading ? (
              <CircularProgress
                style={{
                  display: "flex",
                  justifyContent: "center",
                  margin: "auto",
                }}
              />
            ) : vendorUser.length === 0 ? (
              <Typography
                sx={{ fontSize: "16px", fontWeight: 500, textAlign: "center" }}
              >
                Nenhum usuário encontrado
              </Typography>
            ) : (
              paginatedVendorUsers.map((user: VendorUser) => (
                <Box
                  key={user.id}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    borderTop: "1px solid #E0E0E0",
                  }}
                >
                  <Box sx={{ margin: "12px 90px 12px 7px " }}>
                    <img
                      src={vendorUserLogo}
                      style={{
                        marginBottom: "0px",
                        width: "72px",
                        height: "72px",
                      }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Box>
                      <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
                        {user.name}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: 500,
                          marginBottom: "6px",
                        }}
                      >
                        {user.email}
                      </Typography>
                      <Chip
                        color="primary"
                        sx={{
                          height: "28px",
                          bgcolor: user.isActive ? "#2AD200" : "#FF5C5C",
                          borderRadius: "18px",
                          padding: "1px 8px",
                          // color: "black",
                          textTransform: "capitalize",
                          display: "flex",
                          gap: "1px",
                          alignItems: "center",
                          width: "max-content",
                          "& .MuiChip-label": {
                            fontSize: "16px",
                            fontWeight: "medium",
                          },
                        }}
                        icon={
                          user.isActive ? (
                            <CheckCircleOutlinedIcon />
                          ) : (
                            <CancelOutlinedIcon />
                          )
                        }
                        label={user.isActive ? "Ativo" : "Inativo"}
                      />
                    </Box>
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: "8px" }}
                    >
                      <Typography>{EditIcon}</Typography>
                      <Typography>
                        {user.isActive ? removeIcon : addIcon}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ))
            )}
          </Box>
        </Box>
        {/* Conditionally render pagination */}
      </Box>
      {vendorUser.length > 5 && (
        <ReactPagination
          page={page}
          rowsPerPage={rowsPerPage}
          count={vendorUser.length}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </Box>
  );
};
